<template>
    <div id="invite_detail">
        <div class="bread">
            <el-breadcrumb>
                <el-breadcrumb-item :to="{path: '/course_list',query:{type:type}}">微吼直播列表</el-breadcrumb-item>
                <el-breadcrumb-item>组别数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="back" @click="backPage()"> 返回</div>
        </div>
        <div class="main">
            <div class="courselist-box">
                <div class="titlebox">
                    <div class="title">组别数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})</div>
                    <div class="notice">
                        <span class="refresh" @click="getList">刷新</span>
                    </div>
                </div>
                <div class="navs">
                    <el-form class="course_search_form" ref="course_search_form" size="large">
                        <el-form-item label="直播">
                            <el-select v-model="search.liveId" style="width: 330px" @change="change">
                                <el-option v-for="(item, index) in liveData" :key="index" :label="item.theme" :value="item.livingId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="type || type!=''" style="margin-left: 32px;" label="资源进线时间">
                            <el-date-picker v-model="search.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD" @change="getList" value-format="YYYY-MM-DD">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="navs" v-if="type=='_1'">
                    <el-form class="course_search_form" ref="course_search_form" size="large">
                        <el-form-item label="MCN列表:" style="margin-left: 32px;">
                            <el-select clearable v-model="search.mcnName" @clear="mcnClear" @change="mcnChange">
                                <el-option v-for="(item, index) in mcn" :key="index" :label="item.mcn_name" :value="item.mcn_name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="老师:" style="margin-left: 32px;">
                            <el-select clearable v-model="search.teacherId" @clear="teacherClear" @change="teacherChange">
                                <el-option v-for="(item, index) in teacher" :key="index" :label="item.refferid_name" :value="item.refferid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-left: 32px;color:red;">
                            <span>{{seltxt}}</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="list">
                    <el-table @sort-change="custom_sort" v-loading="loading" element-loading-text="查找数据可能会花费较长时间，请耐心等待..." :data="tableData" style="width: 98%;margin: 0 auto;height: 100%;overflow: auto;" :height="tableHeight" :header-cell-style="{backgroundColor: '#FAFAFA'}" :row-style="{height: '40px'}" :cell-style="{padding: '0'}">
                        <el-table-column label="序号" width="60" align="center" fixed="left">
                            <template #default="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="组别" prop="bmmc" align="center" fixed="left" min-width="160">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row)">{{scope.row.bmmc}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="300" label="听课ip数" sortable="custom" prop="account_num" align="left">
                            <template #default="scope">
                                <div style="display: flex;">
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>③</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num3}}</span>
                                    </div>
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>②</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num2}}</span>
                                    </div>
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>①</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num1}}</span>
                                    </div>
                                    <div class="ipNum">
                                        <span v-if="!type || type==''">/</span>
                                        <span style="margin-left: 6px;font-weight: bold;">{{scope.row.account_num}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <template v-if="type==''">
                            <el-table-column label="最大听课IP数" sortable="custom" prop="account_num4" align="center" width="140">
                                <template #default="scope">
                                    <span>{{scope.row.account_num4 || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="新客户数" sortable="custom" prop="user_x" align="center" width="100">
                                <template #default="scope">
                                    <span>{{scope.row.user_x || '--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="老客户数" sortable="custom" prop="user_old" align="center" width="100">
                                <template #default="scope">
                                    <span>{{scope.row.user_old || '--'}}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column label="退出人数" sortable="custom" prop="out_num" align="center" width="100"></el-table-column>
                        <el-table-column label="10分钟以下" sortable="custom" prop="10time" align="center" width="140"></el-table-column>
                        <el-table-column label="10~29分钟" sortable="custom" prop="23time" align="center" width="140"></el-table-column>
                        <el-table-column label="30分钟及以上" sortable="custom" prop="30time" align="center" width="140"></el-table-column>
                        <el-table-column label="30分钟及以上占比" align="center" width="140">
                            <template #default="scope">
                                <span style="font-weight: bold;">{{scope.row.account_num ? (scope.row['30time']/scope.row.account_num*100).toFixed(2) : '0.00'}}%</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './assets/less/index.less'
import model from './model/model'
import common_m from '@/common/model'
import { reactive } from 'vue'
var that = null

export default {
    data() {
        that = this
        return {
            loading: true,
            navIndex: 0,
            userInfo: null,
            livingId: that.$route.query.liveId || '',
            type: that.$route.query.type || '', //部门类型
            livetype: that.$route.query.livetype || 'all', //直播数据类型
            tableHeight: 500,
            tableData: [],
            media_list: [], // 媒体列表
            activeIndex: 0,
            search: {
                liveId: null,
                date: null,
                departmentId: null,
                mcnName: null,
                teacherId: null,
            },
            liveData: [],
            currentUserInfo: null,
            // department: [],
            mcn: [],
            teacher: [],
            seltxt: '',
        }
    },
    mounted() {
        // 初始化前判断登录态缓存，不存在则跳回列表页
        if (!localStorage.getItem('fallback_ywy_user')) {
            that.$router.replace('/course_list')
            return
        }
        that.$nextTick(() => {
            that.tableHeight = document.querySelector('.list').clientHeight - 40
        })
        that.init()
    },
    methods: {
        init() {
            that.getUserInfo()
            
            that.get_e_live_list()
            // that.getList()
        },
        getUserInfo() {
            common_m.getUserInfo().then(
                function (res) {
                    that.currentUserInfo = res
                    // alert(JSON.stringify(that.currentUserInfo))

                    
                    if (that.type == '_1') {
                        that.getMCN(1)
                    }
                    // that.getDepartment()
                    
                },
                function (err) {
                    console.log(err)
                    that.loading = false
                    that.currentUserInfo = {}

                    // that.get_e_live_list()
                    if (that.type == '_1') {
                        that.getMCN(1)
                    }
                    // that.getDepartment()
                    // that.getList()
                }
            )
        },
        custom_sort(column) {
            let fieldName = column.prop
            let sortingType = column.order
            let tableData = that.tableData
            let sumData = {} //放置总计一行数据
            let otherData = {} //放置--一行数据
            tableData.map((item) => {
                if (item.bmmc == '合计') {
                    sumData = item
                }
                if (item.bmmc == '--') {
                    otherData = item
                }
            })
            switch (sortingType) {
                case 'ascending':
                    tableData = tableData.sort(
                        (a, b) => a[fieldName] - b[fieldName]
                    )
                    break
                case 'descending':
                    tableData = tableData.sort(
                        (a, b) => b[fieldName] - a[fieldName]
                    )
                    break
            }
            tableData.forEach((item, index) => {
                if (item.bmmc == '合计') {
                    tableData.splice(index, 1)
                }
                return item
            })
            tableData.forEach((item, index) => {
                if (item.bmmc == '--') {
                    tableData.splice(index, 1)
                }
                return item
            })
            tableData.unshift(sumData)
            tableData.push(otherData)
        },
        change(id) {
            that.search.liveId = id
            that.getList()
        },
        // changeDate(date){
        //   console.log("date=",date[0])
        // },
        backPage() {
            window.history.back()
        },

        getList() {
            that.seltxt = ''
            that.loading = true
            let params = {
                livingid: that.search.liveId,
                bmbm:
                    that.currentUserInfo && that.currentUserInfo.bmbm
                        ? that.currentUserInfo.bmbm
                        : '',
                type: 1,
                pageIndex: 1,
                pageSize: 50,
            }
            if (!that.search.liveId) {
                params.livingid = that.livingId
            }
            if (that.type && that.type != '' && that.search.date != null) {
                params.begintime = that.search.date[0]
                params.endtime = that.search.date[1]
            }

            // 添加部门、MCN和老师的筛选条件
            // params.depart_id = 1;
            // if (that.search.mcnName != null) {
            //   params.mcn_name = that.search.mcnName
            // }
            if (that.type == '_1' && that.search.teacherId != null) {
                params.refferid = that.search.teacherId
            }
            let bmbm = that.currentUserInfo && that.currentUserInfo.bmbm ? that.currentUserInfo.bmbm : ''
            // alert("测试:"+bmbm)
            model.get_e_live_bm(params, that.type, that.livetype, bmbm).then(
                function (res) {
                    that.loading = false
                    if (res.code == 0) {
                        let list1 = res.list
                        if (list1 == null || list1.length == 0)
                            that.tableData = list1
                        else {
                            let list2 = []
                            let accountNum = 0
                            let accountNum1 = 0
                            let accountNum2 = 0
                            let accountNum3 = 0
                            let accountNum4 = 0
                            let outNum = 0
                            let time10 = 0
                            let time23 = 0
                            let time30 = 0
                            let user_old = 0
                            let user_x = 0
                            let lastData = null

                            for (let i in list1) {
                                let item = list1[i]
                                accountNum += item.account_num
                                accountNum1 += item.account_num1
                                accountNum2 += item.account_num2
                                accountNum3 += item.account_num3
                                accountNum4 += item.account_num4 || 0
                                outNum += item.out_num
                                time10 += item['10time']
                                time23 += item['23time']
                                time30 += item['30time']
                                user_x += item['user_x'] || 0
                                user_old += item['user_old'] || 0
                                if (item.bmmc == '--') lastData = item
                                else list2.push(item)
                            }
                            let new_item = {
                                account_num: accountNum,
                                account_num1: accountNum1,
                                account_num2: accountNum2,
                                account_num3: accountNum3,
                                account_num4: accountNum4 || '--',
                                out_num: outNum,
                                '10time': time10,
                                '23time': time23,
                                '30time': time30,
                                user_old: user_old || '--',
                                user_x: user_x || '--',
                                bmbm: '',
                                bmmc: '合计',
                            }
                            list2.unshift(new_item)
                            if (lastData) {
                                list2.push(lastData)
                            }
                            console.log('list2', list2)
                            that.tableData = list2
                        }
                        // that.page.total = res.total;
                    } else {
                        that.tableData = []
                    }
                },
                function (err) {
                    console.log(err)
                    that.loading = false
                    that.tableData = []
                }
            )
        },

        /**
         * 部门变化处理
         */
        departmentChange() {
            if (that.search.departmentId) {
                that.loading = true
                that.search.mcnName = null
                that.search.teacherId = null
                that.mcn = []
                that.teacher = []
                that.getMCN(that.search.departmentId)
                that.getList()
            }
        },

        /**
         * 获取MCN列表
         */
        getMCN(id) {
            model.getMCN(id).then((res) => {
                if (res.code == 0) {
                    that.mcn = res.data
                }
            })
        },

        /**
         * MCN清空处理
         */
        mcnClear() {
            that.loading = true
            that.search.mcnName = null
            that.search.teacherId = null
            that.getList()
        },

        /**
         * MCN变化处理
         */
        mcnChange() {
            if (that.search.mcnName) {
                // that.loading = true
                that.search.teacherId = null
                that.teacher = []
                that.getTeacher(that.search.mcnName)
                // that.getList()
            }
        },
        /**
         * MCN变化处理
         */
        teacherChange() {
            // 判断是否有选择时间
            if (that.search.date == null) {
                that.seltxt = 'mcn搜索需要选择时间'
            } else {
                that.getList()
            }
        },
        /**
         * 获取老师列表
         */
        getTeacher(name) {
            model.getTeacher(name).then((res) => {
                if (res.code == 0) {
                    that.teacher = res.data
                }
            })
        },

        /**
         * 老师清空处理
         */
        teacherClear() {
            that.loading = true
            that.search.teacherId = null
            that.getList()
        },

        /**
         * 获取列表数据
         */
        get_e_live_list() {
            that.loading = true
            let params = reactive({
                pageIndex: 1,
                pageSize: 20,
                type: 0,
            })
            let bmbm = that.currentUserInfo && that.currentUserInfo.bmbm ? that.currentUserInfo.bmbm : ''
            model.get_e_live_list(params, that.type, bmbm).then((res) => {
                that.loading = false
                if (res.code === 0) {
                    console.log(res)
                    that.liveData = res.list
                    if (that.livingId != '') that.search.liveId = that.livingId
                    else that.search.liveId = res.list[0].livingId
                    that.getList()
                }
            })
        },
        handleChange(index) {
            if (that.loading) {
                return
            }
            that.navIndex = index
            that.getList()
        },

        gotoPage(item) {
            if (item.bmbm == '--') {
                item.bmbm = 'hjsy1_qt'
            }
            // if (item.bmmc != '--') {
            let url = '/course_detail?liveId=' + that.search.liveId
            url += '&bmbm=' + item.bmbm + '&livetype=' + that.livetype

            if (that.search.date != null)
                url += '&date=' + JSON.stringify(that.search.date)
            else url += '&date=[]'

            if (that.type && that.type != '') url += '&type=' + that.type

            // 添加新的搜索条件参数
            if (that.search.departmentId != null)
                url += '&departmentId=' + that.search.departmentId
            if (that.search.mcnName != null)
                url += '&mcnName=' + encodeURIComponent(that.search.mcnName)
            if (that.search.teacherId != null)
                url += '&teacherId=' + that.search.teacherId

            if (that.currentUserInfo.bmbm == item.bmbm)
                window.location.href = url
            else {
                // if (that.currentUserInfo.zwbm != 202 && that.currentUserInfo.zwbm != 331)
                window.location.href = url
            }
            // } else {
            //   if (that.type == '') {
            //     let url = '/course_detail?liveId=' + that.search.liveId
            //     url += '&bmbm=' + item.bmbm + '&livetype=' + that.livetype

            //     if (that.search.date != null)
            //       url += '&date=' + JSON.stringify(that.search.date)
            //     else url += '&date=[]'

            //     if (that.type && that.type != '') url += '&type=' + that.type
            //     if (that.currentUserInfo.bmbm == item.bmbm) {
            //       window.location.href = url
            //     } else {
            //       window.location.href = url
            //     }
            //   }
            // }
        },
        dynamicStyle(item) {
            let className = null
            if (that.currentUserInfo.bmbm == item.bmbm) {
                className = 'caozuo'
            } else {
                // if (that.currentUserInfo.zwbm == 202 || that.currentUserInfo.zwbm == 331)
                //   className = ''
                // else
                className = 'caozuo'
            }

            // if (item.bmmc != '--') {
            //   if (that.currentUserInfo.bmbm == item.bmbm) {
            //     className = 'caozuo'
            //   } else {
            //     // if (that.currentUserInfo.zwbm == 202 || that.currentUserInfo.zwbm == 331)
            //     //   className = ''
            //     // else
            //     className = 'caozuo'
            //   }
            // } else {
            //   if (that.type == '') {
            //     className = 'caozuo'
            //   }
            // }
            return className
        },
    },
}
</script>
